import { render, staticRenderFns } from "./PostYoutubes.vue?vue&type=template&id=2897ec9e"
import script from "./PostYoutubes.vue?vue&type=script&lang=ts"
export * from "./PostYoutubes.vue?vue&type=script&lang=ts"
import style0 from "./PostYoutubes.vue?vue&type=style&index=0&id=2897ec9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./PostYoutubes.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports